import { SET_GRD_SEARCH_FILTER, RESET_GRD_SEARCH_FILTER } from '../actionTypes'

const INIT_PROTOTYPE_STATE = {}
const initialState = JSON.parse(localStorage.getItem('grd_filter')) || {}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_GRD_SEARCH_FILTER:
      let getPayload = {}
      // localStorage.setItem('grd_document_data', JSON.stringify(getPayload))
      return { ...state, ...getPayload }

    case RESET_GRD_SEARCH_FILTER:
      localStorage.removeItem('grd_filter')
      return {}

    default:
      return state
  }
}
